import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { StyledOption } from '../styles'

class Item extends PureComponent {
  handleSelect = () => {
    const { value, label, onSelect } = this.props
    if (onSelect) onSelect(value, label)
  }

  render() {
    const { selected, label, activeColor } = this.props
    return (
      <StyledOption
        activecolor={activeColor}
        selected={selected ? 1 : 0}
        onClick={this.handleSelect}
      >
        {label}
      </StyledOption>
    )
  }
}

Item.defaultProps = {
  activeColor: null,
  selected: false,
}

Item.propTypes = {
  activeColor: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]).isRequired,
  selected: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]).isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default Item
